import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import createSagaMiddleware from 'redux-saga';

import sidebarReducer from 'store/sidebar/reducer';
import { ISidebarState } from 'store/sidebar/types';

import rootSaga from './saga';

export interface IApplicationState {
    sidebar: ISidebarState;
}

interface IStoreOptions {
    isDev?: boolean;
}

const sagaMiddleware = createSagaMiddleware();

const reducers = {
    sidebar: sidebarReducer
};

function configureStore(initialState = {}, options: IStoreOptions = { isDev: true }) {
    const enhancer = (options.isDev ? composeWithDevTools : compose) as typeof compose;
    const composedMiddlewares = enhancer(applyMiddleware(sagaMiddleware));
    const rootReducer = combineReducers<IApplicationState>(reducers);

    const store = createStore(rootReducer, initialState, composedMiddlewares);

    sagaMiddleware.run(rootSaga);

    return store;
}

export default configureStore;
